import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  projectId: "the-cosmic-clock",
  appId: "1:681452034814:web:9bb35f7edc22419a5a23af",
  storageBucket: "the-cosmic-clock.firebasestorage.app",
  apiKey: "AIzaSyAkTUymLzQbrhfKzDf1Aroski9nHw4QjA0",
  authDomain: "the-cosmic-clock.firebaseapp.com",
  messagingSenderId: "681452034814",
  measurementId: "G-V80QKW38G0",
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
export const db = getFirestore(app);
